import { api } from './api'

export const apiAuth = {

  login: (usernameOrEmail, password) => api.post('auth/login', { usernameOrEmail, password }),

  logout: () => {
    return api.get(`auth/log-out`)
  },

  changePassword: (new_password, old_password, username) => {
    return api.post('auth/password/change', { new_password, old_password, username })
  },
  // token
  ///refresh-token

  refeshToken: (refresh_token) => api.get('auth/refresh-token', { refresh_token }),
}
